const React = require("react");
const { useParams } = require("react-router-dom");
const { useInventorySource } = require("../context/InventorySourceContext");
const { ProductCollectionPage } = require("../components/ProductCollectionPage");
const h = React.createElement;
const DropshippingSupplierProducts = () => { const { supplierId } = useParams(); const { t } = useInventorySource(); return h(ProductCollectionPage, { supplierId, title: t("h_inventorySource_supplier_products", "Supplier products"), description: t("h_inventorySource_supplier_products_desc", "Designed products available in this InventorySource store.") }); };
module.exports = { DropshippingSupplierProducts };
